module.exports = __webpack_public_path__ + "img/adult-zen-moccasin-grey_2.8d2a6bc3.jpg";